import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from 'src/store/index'
import {UPDATE_CURRENT_ROUTER_NAME, UPDATE_CURRENT_NEWS_SORT_ID} from 'src/store/mutations-types'

Vue.use(VueRouter)

const router = new VueRouter({
  // mode: 'history',
  base: __dirname,
  routes: routes
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  refreshActiveRouteName(to.name)
  next()
})

export function refreshActiveRouteName (routeName) {
  if (routeName === null || routeName.indexOf('Home') > -1) {
    store.commit(UPDATE_CURRENT_ROUTER_NAME, 'Home')
  } else if (routeName.indexOf('News') > -1) {
    store.commit(UPDATE_CURRENT_NEWS_SORT_ID, '---')
    store.commit(UPDATE_CURRENT_ROUTER_NAME, 'News')
  } else if (routeName.indexOf('Venue') > -1) {
    store.commit(UPDATE_CURRENT_ROUTER_NAME, 'Venue')
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js